__turbopack_context__.v({
  "icon": "x6BYUq_icon",
  "label": "x6BYUq_label",
  "link": "x6BYUq_link",
});
